/**
 * ToolPanelFormBuilder generates tool forms based on the provided form definition Array.
 **/
import React from 'react';
import { FormElement } from '@/hybrid/formbuilder/formBuilder.module';
import { FormBuilder } from '@/hybrid/formbuilder/FormBuilder.page';

interface ToolPanelFormBuilderProps {
  // the formDefinition Array of FormElements defines the form to be rendered
  formDefinition: FormElement[];
  // the function that is called when the form is submitted
  submitFn: () => void;
  // the function that is called when the cancel button is clicked
  closeFn: () => any;
  // id of the tool (legacy - may no longer apply)
  toolId?: string;
  // id of the submitBtnId (legacy - may no longer apply)
  submitBtnId?: string;
  // if debug is enabled then the form values and form errors are rendered below this form;
  debug?: boolean;
  // option to save the valid state in the parent component
  setIsValid?: (isValid: boolean) => void;
  // if true the form is saving and the submit button should be disabled
  formSaveProcessing?: boolean;
  // option to have the submit button say something other than 'Execute'
  submitBtnLabel?: string;
  // option to hide the cancel button
  hideCancel?: boolean;
  // wrap the form in a panel
  wrapInPanel?: boolean;
  // extra classnames applied if not wrapped in panel
  extraClassNamesUnwrapped?: string;
}

export const ToolPanelFormBuilder: React.FunctionComponent<ToolPanelFormBuilderProps> = (props) => {
  return <FormBuilder {...props} />;
};
